import { runWithAnimationFrame, runWithRenderSlice } from "@otto-ec/global-resources/core";
import type { CustomElement } from "./utils";

export const extendElementWithAnimationFrameInit = (Base: CustomElement): CustomElement =>
  class extends Base {
    /*                                       */

    async connectedCallback(): Promise<void> {
      /*                                       */

      /*                                                        */
      return runWithAnimationFrame(() => super.connectedCallback(), {
        /*            */
        /*                              */
      });
    }

    /*                             */
    /*                          */
    /*                                     */
    /**/
  };

export const extendElementWithRenderSliceInit = (Base: CustomElement): CustomElement =>
  class extends Base {
    /*                                       */

    connectedCallback(): Promise<void> {
      /*                                       */

      /*                                                     */
      return runWithRenderSlice(
        () => {
          /*                                                                 */
          /*                              */

          /*             */
          if (this.isConnected === false) return;
          return super.connectedCallback();
        },
        {
          /*            */
          /*                              */
        },
      );
    }

    /*                             */
    /*                                         */
    /*                                                 */
    /*                                       */
    /*  */

    /*                               */
    /*                                        */
    /**/
  };
